import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {HeadEvaluated} from '../../../../head-evaluation/_interfaces/head-evaluated.interface';

@Component({
    selector: 'app-head-edit-final-average',
    templateUrl: './head-edit-final-average.component.html',
    styleUrls: ['./head-edit-final-average.component.scss'],
})
export class HeadEditFinalAverageComponent implements OnInit {
    @Input() userEvaluation: HeadEvaluated = null;
    public finalEvaluation: string = '';

    constructor(
        private _modalController: ModalController,
    ) {
    }

    ngOnInit() {
        if (this.userEvaluation !== undefined && this.userEvaluation !== null) {
            this.userEvaluation.finalEvaluation = !this.userEvaluation.finalEvaluation
                ? this.userEvaluation.initialFinalEvaluation.replace(',', '.')
                : this.userEvaluation.finalEvaluation.replace(',', '.');
        }
    }

    public checkMaxValue(event: any) {
        const inputValue = event.target.value;

        if (inputValue > 999) {
            event.target.value = 999;
            this.finalEvaluation = '999';
        }
    }

    public async setHeadFinalAverage() {
        await this.dismiss(this.finalEvaluation);
    }

    public async dismiss(data: any = null) {
        this.userEvaluation.finalEvaluation = this.finalEvaluation;
        await this._modalController.dismiss(data);
    }
}
